import * as R from "remeda";
import { ChatEvaluationTestExecutionResultMetrics } from "@/API";
import { Button, Tooltip, Text } from "@mantine/core";
import { modals } from "@mantine/modals";

export function MetricBadge(props: { label: string, score?: number | null, description?: string }) {
    const isValid = props.score != null && !Number.isNaN(props.score);
    const displayScore = isValid ? R.round(2)(props.score!) : "無效";

    return (
        <Tooltip label={displayScore}>
            <Button
                radius="xl"
                size="compact-xs"
                color={!isValid ? "gray" : props.score! > 0.75 ? "green" : props.score! >= 0.5 ? "yellow" : "red"}
                onClick={() => {
                    if (props.description) {
                        modals.open({
                            title: '說明',
                            children: (
                                <Text style={{ whiteSpace: "pre-wrap" }}>
                                    {props.description}
                                </Text>
                            ),
                        });
                    }
                }}
            >
                {props.label}: {displayScore}
            </Button>
        </Tooltip>
    );
}

const nv_accuracy_description = "衡量模型回答是否與標準答案一致。\n強調：「回答正不正確。」";
const nv_context_relevance_description = "判斷 Retriever 拿到的內容是否和用戶問題相關。\n強調：「取出的 context 好不好？有沒有抓到題目需要的內容？」";
const nv_response_groundedness_description = "衡量模型回答是否完全根據提供的 context 。\n強調：「模型有沒有胡亂編？回答是否有被上下文支支撑？」";

function calculateAverageMetricScore(
    metricsList: ChatEvaluationTestExecutionResultMetrics[],
    key: string
): number | null {
    if (!metricsList || metricsList.length === 0) return null;

    const validScores: number[] = [];
    metricsList.forEach((metrics) => {
        const score = metrics?.[key]?.score;
        if (score != null && !Number.isNaN(score)) {
            validScores.push(score);
        }
    });

    if (validScores.length === 0) return null;
    const sum = validScores.reduce((a, b) => a + b, 0);
    return sum / validScores.length;
}

export function EvaluationMetricBadges(props: { metricsList: ChatEvaluationTestExecutionResultMetrics[] }) {
    return (
        <>
            <MetricBadge label="答案準確度" description={nv_accuracy_description} score={calculateAverageMetricScore(props.metricsList, "nv_accuracy")} />
            <MetricBadge label="內容相關性" description={nv_context_relevance_description} score={calculateAverageMetricScore(props.metricsList, "nv_context_relevance")} />
            <MetricBadge label="回應根據性" description={nv_response_groundedness_description} score={calculateAverageMetricScore(props.metricsList, "nv_response_groundedness")} />
        </>
    );
}
